import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from '../ManagerDashboard/Profile.module.css';

const UpgradeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  
  if (!isOpen) return null;

  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Upgrade to Elite</h2>
        <p>The "Request Recommendation" feature is only available to Elite members.</p>
        <div className={styles['form-actions']}>
          <button 
            className={styles['secondary-button']} 
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className={styles['primary-button']} 
            onClick={() => navigate('/membership')}
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;